// OBT F3-D — Kapsamdaki parklar (kurumsal hafıza park seçici).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchScopeParks } from '../memoryApi';
import { normalizeObtError } from '../../obtErrors';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useScopeParks({ enabled = true } = {}) {
  const [state, setState] = useState({ loading: enabled, error: null, parks: [] });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!enabled) {
      setState({ loading: false, error: null, parks: [] });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchScopeParks({ signal: controller.signal });
      if (controller.signal.aborted) return;
      setState({
        loading: false,
        error: null,
        parks: Array.isArray(data?.items) ? data.items : [],
      });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({ loading: false, error: normalizeObtError(error), parks: [] });
    }
  }, [enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
